import { Table } from '@shinetools/lumen-react'
import { ReactElement, ReactNode } from 'react'

interface EmptyStateRowProps {
  colSpan: number
  emptyRowInfo: ReactNode
}

export const EmptyStateRow = ({ colSpan, emptyRowInfo }: EmptyStateRowProps): ReactElement => (
  <Table.Row>
    <Table.Cell colSpan={colSpan}>{emptyRowInfo}</Table.Cell>
  </Table.Row>
)
